// comparedly-app/src/services/billing-service.js

import HttpService from "./htttp.service";

class BillingService {
  async createCheckoutSession(priceId, workspaceId) {
    try {
      const payload = { price_id: priceId };
      if (workspaceId) payload.workspace_id = workspaceId;

      const response = await HttpService.post("/billing/create-checkout-session", payload);
      return response.url;
    } catch (error) {
      console.error("Error creating checkout session:", error);
      throw error;
    }
  }

  async getLatestBillingRecord() {
    try {
      const response = await HttpService.get("/billing/latest");
      return response; // ✅ returns the latest billing record
    } catch (error) {
      console.error("❌ Error fetching latest billing record:", error);
      throw error;
    }
  }

  async updateBillingRecord(sessionId, updatePayload = {}) {
    try {
      const payload = { session_id: sessionId, ...updatePayload };
      const response = await HttpService.post(`/billing/update`, payload);
      return response;
    } catch (error) {
      console.error("Error updating billing record:", error);
      throw error;
    }
  }

  /**
  * Sends a request to the backend to schedule the Stripe price change.
  * @param {string} newPriceId - The Stripe Price ID of the lower-tier plan.
  */
  async scheduleDowngrade(newPriceId) {
    try {
      // This endpoint only needs the price ID and the user's context (via auth)
      const response = await HttpService.post("/billing/schedule-downgrade", {
        new_price_id: newPriceId,
      });
      return response;
    } catch (error) {
      console.error("❌ Error scheduling Stripe downgrade:", error);
      throw error;
    }
  }

  async createBillingPortalSession(customerId) {
    try {
      const response = await HttpService.post("/billing/create-portal-session", {
        stripe_customer_id: customerId,
      });

      return response.url; // backend returns { url: "..." }
    } catch (error) {
      console.error("❌ Error creating Stripe billing portal session:", error);
      throw error;
    }
  }


}


export default new BillingService();
